import React from 'react';

import { Formik, Field } from 'formik';
import TimezoneSelect from 'react-timezone-select';
import * as Yup from 'yup';

import Button from 'CommonComponents/Button';
import LocaleDropdown from 'CommonComponents/LocaleDropdown';

const userUpdateRegionalSettingsSchema = Yup.object().shape({
    use_detected_locale: Yup.boolean(),
    manual_locale: Yup.string()
        .min(2)
        .max(15)
        .when('use_detected_locale', {
            is: false,
            then: Yup.string().required('This value is required'),
        }),
});

export default function UserRegionalSettingsForm(props) {
    return (
        <Formik
            initialValues={{
                manual_locale: props?.user?.manual_locale || 'en_US',
                timezone: props?.user?.timezone || 'UTC',
                use_detected_locale: props?.user?.use_detected_locale,
            }}
            validationSchema={userUpdateRegionalSettingsSchema}
            onSubmit={async (values, actions) => {
                let data = { ...values };
                await props.updateRegionalSettings(data);
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue, setFieldTouched, initialValues }) => (
                <div className={'row'}>
                    <div className={'col-12'}>
                        <div className={'card bg-white border-0 rounded-15px py-2 shadow'}>
                            <div className={'card-body'}>
                                <h5 className="card-title">Regional Settings</h5>
                                <div className="form-group row">
                                    <div className="col">
                                        <div className="form-check">
                                            <Field
                                                id="use_detected_locale"
                                                type="checkbox"
                                                name="use_detected_locale"
                                                className={
                                                    errors.use_detected_locale && touched.use_detected_locale
                                                        ? 'form-check-input is-invalid border border-danger'
                                                        : 'form-check-input'
                                                }
                                            />
                                            <label htmlFor="use_detected_locale" className="form-check-label font-weight-bold" style={{ fontSize: '14px' }}>
                                                Use detected locale
                                            </label>
                                            {errors.use_detected_locale && touched.use_detected_locale && (
                                                <div className="text-danger">{errors.use_detected_locale}</div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label htmlFor="manual_locale" className="col-12 col-form-label font-weight-bold" style={{ fontSize: '14px' }}>
                                        Locale
                                    </label>
                                    <div className="col-12">
                                        <LocaleDropdown
                                            name="manual_locale"
                                            isDisabled={values.use_detected_locale}
                                            onBlur={() => setFieldTouched('manual_locale')}
                                            onChange={(locale) => setFieldValue('manual_locale', locale?.value)}
                                            defaultValue={
                                                initialValues.manual_locale && {
                                                    label: initialValues.manual_locale,
                                                    value: initialValues.manual_locale,
                                                }
                                            }
                                        />
                                        {errors.manual_locale && touched.manual_locale && <div className="text-danger">{errors.manual_locale}</div>}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label htmlFor="timezone" className="col-12 col-form-label font-weight-bold" style={{ fontSize: '14px' }}>
                                        Timezone
                                    </label>
                                    <div className="col-12">
                                        <TimezoneSelect
                                            value={values.timezone}
                                            isClearable
                                            isSearchable
                                            classNamePrefix="select"
                                            onChange={(timezone) => setFieldValue('timezone', timezone?.value)}
                                            defaultValue={initialValues.timezone}
                                        />
                                        {errors.timezone && touched.timezone && <div className="text-danger">{errors.timezone}</div>}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 d-flex justify-content-end">
                                        <Button variant="primary" disabled={isSubmitting} onClick={handleSubmit}>
                                            Save
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Formik>
    );
}
